var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-icon-fonts'),_vm._l((_vm.options),function(option){return _c('span',{key:option,staticClass:"option",class:[{ active: _vm.fontFamily === option }, `option--${option}`],on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.update(option)}}},[_vm._v("Aa")])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }